import pcURL from '@planningcenter/url';
import React from 'react';
import apiRequest, { railsCsrfFetch } from '../../chat-core/api_request.js';
import { useChatApi } from './use_chat_api.js';

const LOADING = null;
const useChatConnectedPeople = () => {
    const [people, setPeople] = React.useState(LOADING);
    const loading = people === LOADING;
    const api = useChatApi();
    React.useEffect(() => {
        api.chat.get("me/connected_people").then((people) => setPeople(people));
    }, []);
    return { loading, people, switchPerson };
};
const switchPerson = (toId, returnPath, env) => {
    apiRequest(railsCsrfFetch, `${pcURL(env)("api")}/login/v2/me/switch_connected_person`, {
        data: {
            data: {
                attributes: {
                    id: toId,
                    return_path: returnPath,
                },
            },
        },
        method: "POST",
    }).then(({ json }) => {
        window.location = json.meta.redirect_to;
    });
};

export { switchPerson, useChatConnectedPeople };
//# sourceMappingURL=use_chat_connected_people.js.map
